/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BatchUpdateImportJobRowsRowFromJSON, BatchUpdateImportJobRowsRowToJSON, } from './';
export function BatchUpdateImportJobRowsRequestFromJSON(json) {
    return BatchUpdateImportJobRowsRequestFromJSONTyped(json, false);
}
export function BatchUpdateImportJobRowsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        rows: json['rows'].map(BatchUpdateImportJobRowsRowFromJSON),
    };
}
export function BatchUpdateImportJobRowsRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        rows: value.rows.map(BatchUpdateImportJobRowsRowToJSON),
    };
}
